import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private http: HttpClient,
  ) { }

  getTotalBalance() {
    return this.http.get(environment.walletApiUrl + 'api/dashboard/Totalbalance')
  }

  getTotalBalanceChart() {
    return this.http.get(environment.walletApiUrl + 'api/dashboard/totalBalanceChart')
  }

}
